import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "crm-item__left" }
const _hoisted_2 = { class: "crm-item__body" }
const _hoisted_3 = { class: "crm-item__title" }
const _hoisted_4 = {
  key: 0,
  class: "company"
}
const _hoisted_5 = { class: "crm-item__text" }
const _hoisted_6 = { class: "crm-item__right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-link" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_crm_progress_circle = _resolveComponent("crm-progress-circle")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "crm-item__container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(!_ctx.isLinked ? 'linkToBusiness' : 'navigateToMobiCRM', _ctx.business.id)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_crm_progress_circle, {
        radius: 22,
        stroke: 3,
        step: _ctx.business.stateStep,
        "max-step": _ctx.businessReferenceData?.maxBusinessStep
      }, null, 8, ["step", "max-step"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.business.name), 1),
        (_ctx.business.companyName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "- " + _toDisplayString(_ctx.business.companyName), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.business.stateLabel), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!_ctx.isLinked)
        ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            content: _ctx.$t('BusinessPreview.AssociateTooltip'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["content"]))
        : (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 1,
            content: _ctx.$t('BusinessPreview.AlreadyAssociatedTooltip'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["content"]))
    ])
  ]))
}